/* eslint-disable no-param-reassign */
import { canvasToImage, initCanvas, drawImage } from "utils/canvasUtils";
import { gVisionToNewHead } from "utils/gVisionUtils";
import FacePresenter from "presenters/FacePresenter";

export const zeroFace = {
  scale: 1.0,
  angle: 0.0,
  offset: { x: 0, y: 0 },
  rotation: 0,
};

export const HEAD = {
  width: 400,
  height: 600,
};

export const HEAD_CUT = {
  width: 800,
  height: 600,
};

export const SCALE_HEAD_CUT = 0.7;

const drawHead = (ctx, sourceImage, headObject, transforms) => {
  const { container, rotation: startRotation, faceMidPoint } = headObject;
  const { rotation, scale, offset } = transforms;
  const [image, imageCtx] = initCanvas(sourceImage);
  imageCtx.translate(faceMidPoint.x, faceMidPoint.y);
  imageCtx.rotate(-(startRotation + rotation));
  imageCtx.scale(scale, scale);
  imageCtx.translate(-faceMidPoint.x, -faceMidPoint.y);
  imageCtx.translate(offset.x, offset.y);
  imageCtx.drawImage(sourceImage, 0, 0);
  drawImage(ctx, image, container.x, container.y, container.width, container.height, 0, 0, HEAD.width, HEAD.height);
};

const drawHeadMask = (ctx, mask) => {
  ctx.globalCompositeOperation = "destination-in";
  ctx.drawImage(mask, 0, 0);
};

export const getDefaultTransforms = (transforms) => {
  if (transforms) return { ...transforms, angle: transforms.rotation / (Math.PI / 180) };

  return zeroFace;
};

export const intersectLayers = (face, svgImage, type = "image") => {
  return ["destination-over", "source-in"].map((operation) => {
    const [cnv, ctx] = initCanvas(HEAD);
    ctx.drawImage(svgImage, 0, 0);
    ctx.globalCompositeOperation = operation;
    ctx.drawImage(face, 0, 0);
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(face, 0, 0);
    if (type === "canvas") return cnv;
    return canvasToImage(cnv);
  });
};

export const headCanvas = ({ image, gVisionData, headMask, transforms = {} }) => {
  const [canvas, context] = initCanvas(HEAD);
  const headObject = gVisionToNewHead(gVisionData, image);

  const safeTransforms = getDefaultTransforms(transforms);

  drawHead(context, image, headObject, safeTransforms);
  drawHeadMask(context, headMask);

  return canvas;
};

export const getRandomFace = (faces) => faces[Math.floor(Math.random() * faces.length)];

export const faceCreateAttributes = (key, svg) => {
  return {
    data: {
      attributes: {
        asset: {
          head_key: key,
        },
      },
      relationships: {
        jaw: {
          data: {
            attributes: {
              svg,
            },
            type: "jaws",
          },
        },
      },
      type: "heads",
    },
  };
};

export const faceUpdateAttributes = (personSlug, faceSlug) => {
  return {
    data: {
      id: faceSlug,
      type: "heads",
      relationships: {
        person: {
          data: {
            id: personSlug,
            type: "people",
          },
        },
      },
    },
  };
};

export const faceUpdateJawAttributes = (face, jawSvg) => {
  return {
    data: {
      attributes: {
        asset: FacePresenter.asset(face),
        createdAt: FacePresenter.createdAt(face),
        default: FacePresenter.default(face),
      },
      id: FacePresenter.id(face),
      relationships: {
        jaw: {
          data: {
            attributes: {
              svg: jawSvg,
            },
            type: "jaws",
          },
          person: {
            data: FacePresenter.person(face),
          },
        },
      },
      type: "heads",
    },
  };
};
